import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { saveTranslations } from '../actions';
import RaisedButton from 'material-ui/RaisedButton';

function SaveBtn({ text = 'Save translations', i18, saveCb, saveTranslations, ...propsBtn }) {
    return (
        <RaisedButton
            label={text}
            onClick={() => {
                saveCb ? saveCb(i18) : saveTranslations(i18);
            }}
            {...propsBtn}
        />
    );
}

SaveBtn.propTypes = {
    text: PropTypes.string,
    saveCb: PropTypes.func,
    // From connect
    i18: PropTypes.object.isRequired,
    saveTranslations: PropTypes.func.isRequired,
};

export default connect(
    ({ commonI18Dashboard: { i18 } = {} }) => ({
        i18,
    }),
    { saveTranslations },
)(SaveBtn);



/** WEBPACK FOOTER **
 ** ../src/dash/front/common-i18-dashboard-page/components/SaveBtn.js
 **/